import React from 'react';
import {
  Theme,
  Tooltip,
  TooltipProps,
  createStyles,
  makeStyles
} from '@material-ui/core';

type TProps = {
  title: any;
  children: any;
  placement?: TooltipProps['placement'];
  interactive?: boolean;
};

export const CustomTooltip: React.FC<TProps> = (props: TProps) => {
  const { title, children, placement, interactive } = props;

  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      tooltip: {
        fontSize: 14
      }
    })
  );

  const classes = useStyles();

  return (
    <>
      <Tooltip
        title={title}
        classes={{ tooltip: classes.tooltip }}
        placement={placement}
        interactive={interactive}
      >
        {children}
      </Tooltip>
    </>
  );
};
